import { useContext } from "react";
import { GenerateFileContext } from "./GenerateFileProvider";

export default function useGenerateFileContext() {
    return useContext(GenerateFileContext);
};
